<script setup lang="ts">
import AuthLayoutBase from '@afinius/organisms/AuthLayout/AuthLayout.vue';
import background from '@afinius/theme/images/afinius-auth-background.webp';
import Logo from '@afinius/theme/logos/afinius/afinius.svg?component';
import Cluster from '@afinius/ui-framework/Cluster/Cluster.vue';
import Image from '@afinius/ui-framework/Image/Image.vue';

import AppInfo from '../../../components/AppInfo/AppInfo.vue';
import AppLogo from '../../../components/AppLogo/AppLogo.vue';
</script>

<template>
  <AuthLayoutBase>
    <template #header>
      <Cluster alignItems="end" :gap="2" justifyContent="space-between">
        <Logo class="app-layout__logo" />
        <AppLogo class="app-layout__app-logo" />
      </Cluster>
    </template>

    <template #image>
      <Image :url="background" shouldFill />

      <AppInfo />
    </template>
  </AuthLayoutBase>
</template>

<style lang="scss" scoped>
@use './AppLayout.scss';
</style>
